<h2>{{ "CASE_FORM.FORMS.SUMMARY.DEBTOR_EMAIL_TITLE" | translate }}</h2>
<div class="debtor-email-description top-margin-10">
  {{ "CASE_FORM.FORMS.SUMMARY.DEBTOR_EMAIL_DESCRIPTION" | translate }}
</div>
<div class="top-margin-20">
  <payee-form-field
    width="max"
    height="tall"
  >
    <input
      payee-input
      [placeholder]="'CASE_FORM.FORMS.SUMMARY.DEBTOR_EMAIL_PLACEHOLDER' | translate"
      [formControl]="email"
    />
    @if (email.invalid && email.dirty) {
      <ng-container payee-error>
        @if (email.hasError("required")) {
          <span>
            {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
          </span>
        }
        @if (email.hasError("email")) {
          <span>
            {{ "ERROR_MESSAGES.INVALID_EMAIL" | translate }}
          </span>
        }
        @if (email.hasError("unknown")) {
          <span>
            {{ email.getError("unknown") }}
          </span>
        }
      </ng-container>
    }
  </payee-form-field>
</div>
